import "nodelist-foreach";

const no_content_notice = document.querySelector(".cartRecap--content")
  ? document.querySelector(".cartRecap--content").innerHTML
  : "";

function fillRecap() {
  const c = document.querySelector(".cartRecap--content");
  if (!c) return;

  const mail_recap = document.querySelector('textarea[name="ordered_items"]');
  if (!mail_recap) return false;
  else mail_recap.value = "----\nRécapitulatif de la commande\n";

  const products = JSON.parse(localStorage.getItem("products"));
  if (!products || Object.keys(products).length === 0) {
    c.innerHTML = no_content_notice;
    return;
  } else c.innerHTML = "";

  Object.entries(products).map(([slug, opt]) => {
    c.insertAdjacentHTML(
      "beforeend",
      `
        <tr>
          <td>
            <a href="${opt.url}">
              <b>${opt.title}</b>
              ${opt.subtitle ? "</br>" + opt.subtitle : ""}
            </a>
          </td>
          <td>${opt.price}</td>
          <td>
            <div class="cartRecap--content--btns">
              ${opt.count}
              <button type="button" class="cart_button cart_add__count" data-productslug="${slug}">
                <svg class="svg-icon" viewBox="0 0 20 20">
                  <polygon points="5,15 10,5 15,15"></polygon>
                </svg>
              </button>
              <button type="button" class="cart_button cart_remove__count" data-productslug="${slug}">
                <svg class="svg-icon" viewBox="0 0 20 20">
                  <polygon points="5,5 10,15 15,5"></polygon>
                </svg>
              </button>
              <button type="button" class="cart_button cart_remove__product" data-productslug="${slug}">
                <svg class="svg-icon" viewBox="0 0 20 20">
                  <path  d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
                </svg>
              </button>
            </div>
          </td>
        </tr>
      `
    );
    mail_recap.value += "• " + opt.title;
    if (opt.subtitle) mail_recap.value += " / " + opt.subtitle;
    mail_recap.value += " (" + opt.count + ")" + "\n";
  });

  // todo : set add__count, remove__product and remove__count to do something
  const remove_btns = document.querySelectorAll(".cart_remove__product");
  if (remove_btns)
    remove_btns.forEach((btn) => {
      btn.addEventListener("click", function () {
        const slug = this.dataset.productslug;
        let products = JSON.parse(localStorage.getItem("products"));
        delete products[slug];
        localStorage.setItem("products", JSON.stringify(products));

        fillRecap();
      });
    });

  const add_btns = document.querySelectorAll(".cart_add__count");
  if (add_btns)
    add_btns.forEach((btn) => {
      btn.addEventListener("click", function () {
        const slug = this.dataset.productslug;
        let products = JSON.parse(localStorage.getItem("products"));
        products[slug].count++;
        localStorage.setItem("products", JSON.stringify(products));

        fillRecap();
      });
    });

  const remove_count_btns = document.querySelectorAll(".cart_remove__count");
  if (remove_count_btns)
    remove_count_btns.forEach((btn) => {
      btn.addEventListener("click", function () {
        const slug = this.dataset.productslug;
        let products = JSON.parse(localStorage.getItem("products"));
        if (products[slug].count <= 1) delete products[slug];
        else products[slug].count--;
        localStorage.setItem("products", JSON.stringify(products));

        fillRecap();
      });
    });
}

function clickAddProduct() {
  console.log("clickAddProduct");
  const btn = document.querySelector(".cart__button");
  if (!btn) return;

  window.dispatchEvent(
    new CustomEvent("addProduct", {
      detail: {
        product: {
          slug: btn.dataset.productslug,
          title: btn.dataset.producttitle,
          subtitle: btn.dataset.productsubtitle,
          price: btn.dataset.productprice,
        },
      },
    })
  );

  // if (!document.querySelector(".added_notice")) return;
  // document.querySelector(".added_notice").innerHTML = `
  //     <span><?= l::get('shop.object_added') ?></span>
  //   `;

  // setTimeout(() => {
  //   if (document.querySelector(".added_notice").length > 0)
  //     document.querySelector(".added_notice").innerHTML = "";
  // }, 2000);
}

function addToCart() {
  const btn = document.querySelector(".cart__button");
  if (!btn) return;

  btn.removeEventListener("click", clickAddProduct);
  btn.addEventListener("click", clickAddProduct);
}

function createCGVButton() {
  console.log("init createCGVButton");

  const btn = document.querySelector("input[type='submit']");
  const text = window.cgv_text;
  if (!btn || !text) return;

  const checkbox = `
  <div class="form__field _checkbox_cgv">
    <input id="ordered_items262e28b80683d7" class="cgv_input" type="checkbox" name="cgv_input">
    <label>
      ${window.cgv_text}<abbr class="form__field-label-required" title="Required">*</abbr>
    </label>
  </div>  
  `;

  btn.parentElement.insertAdjacentHTML("beforebegin", checkbox);

  btn.setAttribute("disabled", true);

  document.querySelector(".cgv_input").addEventListener("change", () => {
    const checked = document.querySelector(".cgv_input").checked;
    if (checked) btn.removeAttribute("disabled");
    else btn.setAttribute("disabled", true);
  });
}

export default ({} = {}) => {
  console.log("init cart recap");

  fillRecap();
  addToCart();
  createCGVButton();

  return {
    destroy: undefined,
  };
};
